import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingStateProps {
  message?: string;
  /** `page` centres in a tall region; `inline` is a short centred block. */
  size?: 'page' | 'inline';
}

/**
 * The one spinner block. Pages used to write their own centred
 * `CircularProgress` box in roughly 270 places.
 */
export const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Loading...', size = 'inline' }) => (
  <Box
    role="status"
    sx={
      size === 'page'
        ? { minHeight: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }
        : { py: 6, textAlign: 'center' }
    }
  >
    <CircularProgress size={28} />
    {message && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
        {message}
      </Typography>
    )}
  </Box>
);
